/**
 * Header menu UI component
 */
import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import _ from 'lodash';


//will add classes 'show' and 'item-selected' selected to menu items 
//in order to hide and show various sub-menus in the nav header
const handleClick = (e, data) => { 
  e.stopPropagation();
  let x = document.getElementsByClassName("sub-menu__wrap");
  [].forEach.call(x, function(el) {
    el.classList.remove("show");
  });
  if(containsClass("show", e)){
    e.target.nextSibling.classList.remove('show');
  }
  else{
    e.target.nextSibling.classList.add('show');    
  }
  if(containsClass("item-selected", e )){
    hideMenus();
    removeAllItemSelectedClasses();
  }
  else{
    e.target.nextSibling.classList.add('item-selected');  
  }
}

//helper function, checks if element  'e' (e holds target element) class contains 'classToCheck'
const containsClass = (classToCheck, e) => {
  var hasClass = false;
  e.target.nextSibling.classList.forEach((item) => {
    if(item == classToCheck){
      hasClass = true;  
    }
  });
  return hasClass;
}

//hides all sub-menus in nav header
const hideMenus = () => {
  let x = document.getElementsByClassName("sub-menu__wrap");
  document.querySelectorAll(".sub-menu__wrap").forEach.call(x, function(el) {
    el.classList.remove("show");
  });
}

//removes all 'item-selected' classes that aids in displaying stuff in nav header
const removeAllItemSelectedClasses = () => {
  let x = document.getElementsByClassName("sub-menu__wrap");
  document.querySelectorAll(".sub-menu__wrap").forEach.call(x, function(el) {
    el.classList.remove("item-selected");
  });
}




const MainMenu = () => {

  const data = useStaticQuery(graphql`
    {
      allWpMenuItem(filter: {menu: {node: {name: {regex: "/Primary/"}}}}) {
        nodes {
          url
          label
          childItems {
            nodes {
              label
              url
              parentDatabaseId
              cssClasses
            }
          }
          parentDatabaseId
        }
      }
    }
  `)

  const menuItems = data.allWpMenuItem.nodes;

  const menu = menuItems.map((menuItem,index) => {

    if ((!_.isNil(menuItem.childItems.nodes[0]))){
      var outerIndex = index;
      return(
        <li className="js-focus-within menu-item menu-item-has-children" key={index}>

            <span tabIndex="0" dangerouslySetInnerHTML={{ __html: menuItem.label }} className="hasChildren" 
                  onClick={handleClick} onKeyDown={handleClick} role="button" value="false" />

            <div  className="sub-menu__wrap">
              <ul className="sub-menu container">
                {menuItem.childItems.nodes.map((menuChildItem, index)=>{
                  var innerIndex = "" + outerIndex + index;
                  return (
                    <li key={innerIndex} className={menuChildItem.cssClasses.join(' ')}>
                      <a href={menuChildItem.url}> <span dangerouslySetInnerHTML={{ __html: menuChildItem.label }} /></a>
                    </li>
                  )
                  })
                }
              </ul>
            </div>
        </li>
      )
    } else if(menuItem.url== 'https://account.southglos.gov.uk' && menuItem.parentDatabaseId === 0 ) {
      return (
        <li className="menu-item menu-item--sign-in" key={index} title="Sign in to your account" >
          <a href={menuItem.url} target="_blank">
            <span dangerouslySetInnerHTML={{ __html: menuItem.label }}  />
          </a>
        </li>
      )
    } else if(menuItem.parentDatabaseId === 0 ) {
      return (
        <li className="menu-item" key={index}  >
          <a href={menuItem.url}>
            <span dangerouslySetInnerHTML={{ __html: menuItem.label }}  />
          </a>
        </li>
      )
    } else {
      return null
    }

    
  })

  return (
    <ul id="menu-primary-navigation" className="menu" >
        {menu}
    </ul>
  )

}


export default MainMenu